// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__rqDkx","choiceBoxes":"toolbarselects_choiceBoxes__3YCcM","simpleField":"toolbarselects_simpleField__3lZ70"};